import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function getCSEventCategoryList(data) {
	let response = await getAPIResponse("/v1/cs/event-category-list", data);
	if (response === null) {
		return null;
	}
	return response;
}